/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { UPDATE_COUPON } from "../graphql";
import { VApplication } from "../../../application";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IUpdateCouponMethods extends IPluginMethodMap {
  updateCouponProps(args: any): Promise<any>;
}

export class UpdateCouponService implements IAgentPlugin {
  readonly methods: IUpdateCouponMethods;

  constructor() {
    this.methods = {
      updateCouponProps: this.updateCouponProps.bind(this),
    };
  }

  async updateCouponProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    console.log(args, "ArgsupdateCoupon");
    try {
      if (client) {
        const res = await client.mutate({
          mutation: UPDATE_COUPON,
          variables: {
            filter: {
              _id: args.id,
            },
            update: {
              ...args.formData,
            },
          },
          fetchPolicy: "no-cache",
        });
        console.log("Update Coupon final data", res?.data);
        console.log(
          "Update Coupon final data in xyuuh",
          res?.data?.UpdateCoupon
        );
        return res?.data?.UpdateCoupon;
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
